module.exports = __webpack_public_path__ + "media/images/quiz-1fdec5fc9037cd5f583324b46b6719ce.svg";